import { useGlobal } from "../../../contexts/globalContext";
import { useJanusContext } from "../../../contexts/janus/JanusContext";
import Janus from "../../../utils/janus";

import { SCREEN_SWITCH_STEP_COLLECTION } from "./constants";

export const useScreenSwitchUtils = () => {
  const {
    SCREEN_SWITCH_DEBUG_PANEL,
    DEBUG_MINI_VIDEO_101,
    SET_SCREEN_SWITCH_PROGGRESS,
    SET_MINI_TRACKS,
    MEDIA_TRACKS,
    SCREEN_STREAM_MINI_REF,
    VIDEO_MINI,
    VIDEO_MAIN,
  } = useGlobal();

  const { oldScreensArray } = useJanusContext();

  const stepsKeys = Object.values(SCREEN_SWITCH_STEP_COLLECTION).filter((stepKey) => !stepKey.includes("console.log"));
  const stepProgressCoefficient = 100 / stepsKeys.length;

  const showDebugMiniVideos = () => {
    if (!SCREEN_SWITCH_DEBUG_PANEL) return;

    const stream = new MediaStream();
    Janus.attachMediaStream(DEBUG_MINI_VIDEO_101.current, stream);
  };
  const updateProgress = (step) => {
    console.log("updateProgress step: ", step);
    const progress = stepsKeys.indexOf(step) + 1;
    SET_SCREEN_SWITCH_PROGGRESS(stepProgressCoefficient * progress);
  };

  const prepareMini = () => {
    const minis = oldScreensArray
      .filter((screen) => screen.id > 0)
      .map((screen) => {
        console.log(screen, screen.mini_track_name, MEDIA_TRACKS, MEDIA_TRACKS[screen.mini_track_name]);
        const stream = new MediaStream();
        stream.addTrack(MEDIA_TRACKS[screen.mini_track_name]);
        return { [screen.mini_track_name]: stream };
      });
    SET_MINI_TRACKS(minis);
    return minis;
  };

  const setMini = (id, minis) => {
    const correctId = id > 200 ? id - 100 : id;

    minis.forEach((track) => {
      const [key, value] = Object.entries(track)[0];
      if (key.includes(correctId + 1)) {
        SCREEN_STREAM_MINI_REF.current = value;
        if (VIDEO_MINI.current) {
          VIDEO_MINI.current.srcObject = value;
          VIDEO_MINI.current.style.opacity = 1;
        } else console.error("VIDEO_MINI.current is possibly not defined or null", VIDEO_MINI.current);

        if (!document.fullscreenElement) {
          if (VIDEO_MAIN.current) VIDEO_MAIN.current.style.opacity = 0;
          else console.error("VIDEO_MAIN.current is possibly not defined or null", VIDEO_MAIN.current);
        }
      }
    });
  };

  return {
    showDebugMiniVideos,
    updateProgress,
    prepareMini,
    setMini,
  };
};
